import React from 'react';
import { Layout, Menu, message, Result, Dropdown } from 'antd';
import { Link, Redirect, Route, Switch } from 'react-router-dom';
import { MenuUnfoldOutlined, MenuFoldOutlined } from '@ant-design/icons';
import cookie from './utils/cookie';
import { menu_list } from './utils/menu';
import auth from './utils/auth';
import { PostForm } from './utils/http';

const { Sider, Content } = Layout;
const { SubMenu, Item } = Menu;

class SiderDemo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      collapsed: false,
      openKeys: [],
    };
  }

  toggle = () => {
    const { collapsed } = this.state;
    this.setState({ collapsed: !collapsed });
  };
  onOpenChange = (openKeys) => {
    this.setState({ openKeys })
  }

  renderMenu = () => {
    const totalMenu = [];
    menu_list.forEach((menu) => {
      const subMenu = this.renderMenuItem(menu);
      subMenu && totalMenu.push(subMenu);
    });
    return totalMenu;
  }
  renderMenuItem = (menuItem) => {
    const { collapsed } = this.state;
    let childMenu = menuItem.children.map((item) => {
      if (item.children) {
        return this.renderMenuItem(item);
      }
      const target = (
        <Item key={item.router || item.key}>
          <Link to={item.router}>{item.title}</Link>
        </Item>
      );
      let auths = [];
      item.auth.forEach((a) => {
        auths.push(a.key);
      })
      console.log("auths", auths);
      return auth.checkAuth(auths) ? target : null;
    });
    childMenu = childMenu.filter(c => c !== null);
    if (childMenu.length === 0) return null;
    return (
      <SubMenu
        key={menuItem.router || menuItem.key}
        title={
          <span>
            {menuItem.icon}{collapsed ? null : menuItem.title}
          </span>
        }
      >
        {childMenu}
      </SubMenu>
    );
  }

  handleLogout = () => {
    PostForm({
      url: '/api/user/logout',
      success: () => {
        cookie.del('a');
        cookie.del('u');
        this.props.history.push('/login');
      },
      error: ({ msg = '操作失败' }) => {
        message.error(msg);
      }
    })
  }

  render() {
    const userName = cookie.get('u');
    const menu = (
      <Menu style={{ textAlign: 'center' }}>
        <Item>
          <span onClick={this.handleLogout}>退出登录</span>
        </Item>
      </Menu>
    );
    const { collapsed, openKeys } = this.state;
    const { location } = this.props;
    return (
      <Layout style={{ minHeight: '100vh' }}>
        <Sider trigger={null} collapsible collapsed={collapsed}>
          <div style={{ height: 20 }}></div>
          <Menu
            theme="dark"
            mode="inline"
            openKeys={[openKeys[openKeys.length - 1]]}
            selectedKeys={[location.pathname]}
            onOpenChange={this.onOpenChange}
          >
            {this.renderMenu()}
          </Menu>
        </Sider>
        <Layout className="site-layout">
          <div style={{ height: 20 }}>
            <span onClick={this.toggle}>
              {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            </span>
            <Dropdown className='logout' overlay={menu} placement="bottomCenter">
              <div className="link">{userName}</div>
            </Dropdown>
          </div>
          <Content>
            <Switch>
              <Route exact path="/">
                <img
                  className="home"
                  src="//gw.alipayobjects.com/zos/rmsportal/TVYTbAXWheQpRcWDaDMu.svg"
                  alt=""
                />
              </Route>
              {
                menu_list.map(
                  item => item.children.map((it) => {
                    let auths = [];
                    it.auth.forEach((a) => {
                      auths.push(a.key);
                    })
                    if (location.pathname === it.router && !auth.checkAuth(auths)) {
                      return <Redirect to="/login" />;
                    }
                    return <Route key={it.router} path={it.router} component={it.com} />
                  })
                )
              }
              <Route>
                <Result
                  status="404"
                  title="404"
                  subTitle="页面跑到其他星球去了"
                  extra={<Link to="/">返回首页</Link>}
                />
              </Route>
            </Switch>
          </Content>
        </Layout>
      </Layout>
    );
  }
}

export default SiderDemo;